import { Box, TextField as MuiTextField, TextFieldProps } from '@mui/material';

export type ControllerSelectProps = Omit<TextFieldProps, 'select' | 'multiline'> & {
  errorText?: string;
};

export const ControllerSelect = function (props: ControllerSelectProps) {
  const { errorText, helperText, placeholder, value, SelectProps, InputLabelProps, ...selectProps } = props;
  const displayEmpty = !!placeholder && !value;

  return (
    <MuiTextField
      select
      value={value}
      helperText={props.error && errorText ? errorText : helperText}
      SelectProps={{
        displayEmpty: displayEmpty,
        renderValue: displayEmpty ? (val) => !val && <Box>{placeholder}</Box> : undefined,
        ...SelectProps,
      }}
      InputLabelProps={{ shrink: !!placeholder || InputLabelProps?.shrink, ...InputLabelProps }}
      {...selectProps}
    />
  );
};

ControllerSelect.displayName = 'ControllerSelect';
